import { AutogenModelEdistatusComment, AutogenRowEdistatusComment } from "./autogen/AutogenModelEdistatusComment";

export class ModelEdistatusComment extends AutogenModelEdistatusComment<RowEdistatusComment> {
	constructor() {
		super(RowEdistatusComment);
	}
}

export class RowEdistatusComment extends AutogenRowEdistatusComment {
}